"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.errorDictionary = void 0;
exports.errorDictionary = {
    common_1: {
        localeKey: "serverError_common_1",
        logMessage: "Unknown error",
    },
    net_1: {
        localeKey: "serverError_net_1",
        logMessage: "Network error",
    },
    auth_1: {
        localeKey: "serverError_auth_1",
        logMessage: "Login not found",
    },
    business_1: {
        localeKey: "serverError_business_1",
        logMessage: "Access denied! Attemt to upsert foreign business",
    },
    service_1: {
        localeKey: "serverError_service_1",
        logMessage: "Business not found",
    },
    service_2: {
        localeKey: "serverError_service_2",
        logMessage: "Access denied! Attemt to upsert foreign service",
    },
    client_1: {
        localeKey: "serverError_client_1",
        logMessage: "Access denied! Attemt to upsert foreign client",
    },
    contact_1: {
        localeKey: "serverError_contact_1",
        logMessage: "Access denied! Attemt to upsert contact without business",
    },
    contact_2: {
        localeKey: "serverError_contact_2",
        logMessage: "Access denied! Attemt to upsert foreign contact",
    },
    booking_1: {
        localeKey: "serverError_booking_1",
        logMessage: "Service not found",
    },
    booking_2: {
        localeKey: "serverError_booking_2",
        logMessage: "Business not found",
    },
    booking_3: {
        localeKey: "serverError_booking_3",
        logMessage: "Client not found",
    },
    booking_4: {
        localeKey: "serverError_booking_4",
        logMessage: "Attemt to upsert booking for other business and client",
    },
    booking_5: {
        localeKey: "serverError_booking_5",
        logMessage: "Access denied! Attemt to upsert foreign booking",
    },
    businessContact_1: {
        localeKey: "serverError_businessContact_1",
        logMessage: "Business not found",
    },
    businessContact_2: {
        localeKey: "serverError_businessContact_2",
        logMessage: "Access denied! Attemt to upsert foreign contact info",
    },
    clientContact_1: {
        localeKey: "serverError_clientContact_1",
        logMessage: "Client not found",
    },
    clientContact_2: {
        localeKey: "serverError_clientContact_2",
        logMessage: "Access denied! Attemt to upsert foreign contact info",
    },
};
//# sourceMappingURL=errorDictionary.js.map